import { render } from "./EditDialog.vue?vue&type=template&id=b2ef9ebc&scoped=true"
import script from "./EditDialog.vue?vue&type=script&lang=js"
export * from "./EditDialog.vue?vue&type=script&lang=js"

import "./EditDialog.vue?vue&type=style&index=0&id=b2ef9ebc&lang=less&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ef9ebc"]])

export default __exports__